export type CookieCategory = 'necessary' | 'media' | 'social' | 'analytics';

export interface CookieConsent {
  version: number;
  givenAt?: string;
  choices: Record<CookieCategory, boolean>;
}

export const DEFAULT_CONSENT: CookieConsent = {
  version: 1,
  choices: {
    necessary: true,
    media: false,
    social: false,
    analytics: false,
  },
};
